import { del, get, post, put } from "../helpers/api_helper"

export const BrokerService = {

  getBrokerList: async () => {
    return get('/brokers/all');
  },

  getBrokerByCrmIdList: async (crmId: number, params?: any) => {
    return get(`/brokers/all/crm/${crmId}`, {params: params})
  },
}